import type {
  CountdownGameState,
  GameStates,
  GetReadyGameState,
  LobbyGameState,
  QuestionGameState,
  QuizEndedGameState,
  ResultGameState,
  ResultScoreGameState,
} from './payloads/gameStates';
import type {
  PresenterChangePlayerName,
  PresenterCreateQuiz,
  PresenterEndQuiz,
  PresenterMarkedAnswer,
  PresenterStartCountDown,
  PresenterStartQuiz,
  VoterPlayerJoin,
  VoterPlayerResults,
  VoterPlayerVote,
} from './payloads/routeInputs';

export enum PresenterRoutes {
  CreateQuiz = 'presenter_create_quiz',
  MarkedAnswer = 'presenter_marked_answer',
  EndQuiz = 'presenter_end_quiz',
  StartQuiz = 'presenter_start_quiz',
  StartCountdown = 'presenter_start_countdown',
  PlayerChangeName = 'player_change_name',
}

export enum FollowerRoutes {
  Join = 'follower_join',
}

export enum VoterRoutes {
  PlayerJoin = 'player_join',
  PlayerVote = 'player_vote',
  PlayerResults = 'player_get_result',
}

interface RouteDef<RequestPayload, Response> {
  payload: RequestPayload;
  response: Response;
}

export interface RouteMap {
  [PresenterRoutes.CreateQuiz]: RouteDef<
    PresenterCreateQuiz,
    QuizEndedGameState | LobbyGameState
  >;
  [PresenterRoutes.MarkedAnswer]: RouteDef<
    PresenterMarkedAnswer,
    QuizEndedGameState
  >;
  [PresenterRoutes.EndQuiz]: RouteDef<PresenterEndQuiz, QuizEndedGameState>;
  [PresenterRoutes.StartQuiz]: RouteDef<PresenterStartQuiz, GetReadyGameState>;
  [PresenterRoutes.StartCountdown]: RouteDef<
    PresenterStartCountDown,
    CountdownGameState
  >;
  [PresenterRoutes.PlayerChangeName]: RouteDef<
    PresenterChangePlayerName,
    ResultGameState
  >;
  [VoterRoutes.PlayerJoin]: RouteDef<VoterPlayerJoin, GameStates>;
  [VoterRoutes.PlayerVote]: RouteDef<VoterPlayerVote, QuestionGameState>;
  [VoterRoutes.PlayerResults]: RouteDef<
    VoterPlayerResults,
    ResultScoreGameState
  >;
  [FollowerRoutes.Join]: RouteDef<undefined, GameStates>;
}
